export const PAGE_SIZE = 20;

export const notifications = [
  { reward: '恭喜 用户1027658获得1000云豆奖励', id: 1 },
  { reward: '恭喜 用户1027659获得30元话费奖励', id: 2 },
  { reward: '恭喜 用户1027660获得14天加成卡奖励', id: 3 },
];

// export const steps = [
//   {
//     icon: require("@/assets/images/assist/process-gift.png"),
//     text: "选择1个奖品",
//   },
//   {
//     icon: require("@/assets/images/assist/process-invite.png"),
//     text: "邀请好友助力",
//   },
//   {
//     icon: require("@/assets/images/assist/process-success.png"),
//     text: "助力成功",
//   },
//   {
//     icon: require("@/assets/images/assist/process-reward.png"),
//     text: "奖品发放到账",
//   },
// ];

export const assistRecord = [
  { avatar: '', name: '李*月', assistValue: 20 },
  { avatar: '', name: '张*管', assistValue: 20 },
  { avatar: '', name: '苏*宣', assistValue: 20 },
  { avatar: '', name: '王*晓', assistValue: 20 },
  { avatar: '', name: '李*月', assistValue: 20 },
  { avatar: '', name: '张*管', assistValue: 20 },
  { avatar: '', name: '苏*宣', assistValue: 20 },
  { avatar: '', name: '王*晓', assistValue: 20 },
];

export const REWARD_TYPE = {
  CLOUD_BEAD: 1, // 云豆
  ADDITION_CARD: 2, // 加成卡
  VIDEO_MEMBER: 3, // 视频会员
  PHONE_BILL: 4, // 话费
};

// export const rewards = [
//   {
//     id: REWARD_TYPE.CLOUD_BEAD,
//     title: "2位新用户助力 必得2元",
//     image: require("@/assets/images/assist/reward-beans.png"),
//   },
//   {
//     id: REWARD_TYPE.ADDITION_CARD,
//     title: "2位新用户助力 即可得",
//     image: require("@/assets/images/assist/reward-card.png"),
//   },
//   {
//     id: REWARD_TYPE.VIDEO_MEMBER,
//     title: "邀4位新用户首绑 畅享月卡",
//     image: require("@/assets/images/assist/reward-vip.png"),
//   },
//   {
//     id: REWARD_TYPE.PHONE_BILL,
//     title: "5位新用户助力 必得5元",
//     image: require("@/assets/images/assist/phone-bill.png"),
//   },
// ];

// export const assistProgressConfig = {
//   [REWARD_TYPE.CLOUD_BEAD]: {
//     total: 1500,
//     stages: [
//       {
//         value: 200,
//         threshold: 200,
//         image: require("@/assets/images/assist/chest-small.png"),
//       },
//       {
//         value: 500,
//         threshold: 800,
//         image: require("@/assets/images/assist/chest-medium.png"),
//       },
//       {
//         value: 1000,
//         threshold: 1500,
//         image: require("@/assets/images/assist/chest-big.png"),
//       },
//     ],
//     unit: "云豆",
//   },
//   [REWARD_TYPE.ADDITION_CARD]: {
//     total: 1300,
//     stages: [
//       {
//         value: "15%",
//         threshold: 200,
//         duration: 7,
//         image: require("@/assets/images/assist/chest-small.png"),
//       },
//       {
//         value: "15%",
//         threshold: 600,
//         duration: 14,
//         image: require("@/assets/images/assist/chest-medium.png"),
//       },
//       {
//         value: "30%",
//         threshold: 1300,
//         duration: 14,
//         image: require("@/assets/images/assist/chest-big.png"),
//       },
//     ],
//     unit: "倍",
//   },
//   [REWARD_TYPE.VIDEO_MEMBER]: {
//     total: 6000,
//     stages: [
//       {
//         value: "月卡",
//         threshold: 2500,
//         image: require("@/assets/images/assist/chest-small.png"),
//       },
//       {
//         value: "季卡",
//         threshold: 6000,
//         image: require("@/assets/images/assist/chest-big.png"),
//       },
//     ],
//     unit: "天",
//   },
//   [REWARD_TYPE.PHONE_BILL]: {
//     total: 4000,
//     stages: [
//       {
//         value: 5,
//         threshold: 500,
//         image: require("@/assets/images/assist/chest-small.png"),
//       },
//       {
//         value: 10,
//         threshold: 1500,
//         image: require("@/assets/images/assist/chest-medium.png"),
//       },
//       {
//         value: 30,
//         threshold: 4000,
//         image: require("@/assets/images/assist/chest-big.png"),
//       },
//     ],
//     unit: "元",
//   },
// };
